export const UPDATE_WHATSAPP_CONFIRMATION_CHARGES_REQUEST = "UPDATE_WHATSAPP_CONFIRMATION_CHARGES_REQUEST";
export const UPDATE_WHATSAPP_CONFIRMATION_CHARGES_SUCCESS = "UPDATE_WHATSAPP_CONFIRMATION_CHARGES_SUCCESS";
export const UPDATE_WHATSAPP_CONFIRMATION_CHARGES_FAILURE = "UPDATE_WHATSAPP_CONFIRMATION_CHARGES_FAILURE";
export const UPDATE_WHATSAPP_CONFIRMATION_CHARGES_RESET = "UPDATE_WHATSAPP_CONFIRMATION_CHARGES_RESET";
export const updateWhatsappConfirmationChargesRequest = (payload) => ({
    type: UPDATE_WHATSAPP_CONFIRMATION_CHARGES_REQUEST,
    payload,
});
export const updateWhatsappConfirmationChargesSuccess = (payload) => ({
    type: UPDATE_WHATSAPP_CONFIRMATION_CHARGES_SUCCESS,
    payload,
});
export const updateWhatsappConfirmationChargesFailure = (payload) => ({
    type: UPDATE_WHATSAPP_CONFIRMATION_CHARGES_FAILURE,
    payload,
});
export const updateWhatsappConfirmationChargesReset = () => ({
    type: UPDATE_WHATSAPP_CONFIRMATION_CHARGES_RESET,
});
